<template>
    <div class="page-container">
        <div class="page-top">
            <div>请为账号 <span>{{mobile}}</span></div>
            <div>设置6位数字的交易密码</div>
            <div style="margin-top:20px;">(该密码将用于您进货、提货以及兑换奖励时)</div>
        </div>
        <div class="page-content">
            <div class="input-grp">
                <input type="password" maxlength="6" v-model="passwd1" @input="passwd1Error = false" placeholder="请输入密码">
                <div class="notice" v-show="passwd1Error">交易密码不能是重复连续的数字</div>
            </div>
            <div class="input-grp">
                <input type="password" maxlength="6" v-model="passwd2" @input="passwd2Error = false" placeholder="再次输入密码">
                <div class="notice" v-show="passwd2Error">两次密码输入不一致</div>
            </div>
            <div class="btn-confirm" @click="confirm">确认</div>
            <!-- <div class="btn-confirm disabled">确认</div> -->
        </div>
    </div>
</template>
<script>
import { Field,Toast } from 'vant'
import {phoneYm} from '@/lib/util'
import $http from '@/lib/request'
import config from '@/config'
import md5 from 'js-md5'

export default {
    data(){
        return {
            passwd1:'',
            passwd2:'',
            passwd1Error:false,
            passwd2Error:false,
            mobile:'',//用户手机号
        }
    },
    components:{
        [Field.name]:Field,
        [Toast.name]:Toast
    },
    activated(){
        this.mobile=phoneYm(JSON.parse(window.localStorage.getItem('userInfo')).mobile)
    },
    deactivated(){
        this.passwd1='';
        this.passwd2='';
        this.passwd1Error=false;
        this.passwd2Error=false;
        this.mobile='';//用户手机号
    },
    methods:{
        confirm(){
            // let pattern = /^[0-9]*$/;
            // if(pattern.test(this.passwd1)){
            //     this.passwd1Error=true;
            //     return;
            // }
            if(this.passwd1 !== this.passwd2){
                this.passwd2Error=true;
                return;
            }
            let reg=/^\d{6}$/;
            if(!reg.test(this.passwd1) || !reg.test(this.passwd2)){
                Toast('请设置6位数字的密码');
                return;
            }
            $http({
                method:'post',
                data:{
                    jyPassword:md5(this.passwd2)
                },
                url:config.api.setJypass
            }).then((res)=>{
                if(res.errno == 0){
                    Toast('密码设置成功！');
                    setTimeout(()=>{
                        this.$router.replace({
                            name:'back-index',
                        });
                    },1000);
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-cell::after{
    border-bottom: none;
}
.page-container{
    padding:15px;
    background: #f5f5f5;
    box-sizing: border-box;
    min-height: 100vh;
    .page-top{
        padding:10px;
        margin-bottom: 40px;
        &>div{
            color:#333;
            line-height: 28px;
            font-size: 15px;
            text-align: center;
            &>span{
                margin-left: 5px;
                font-size: 18px;
            }
            margin-bottom: 5px;
        }
    }
    .page-content{
        .input-grp{
            margin-bottom: 15px;
            &>input{
                display: block;
                width:100%;
                height:44px;
                background:#fff;
                border:none;
                box-sizing: border-box;
                padding:0 20px;
                border-radius: 4px;
            }
            .notice{
                margin-top: 8px;
                font-size: 12px;
                color:#e43d3d;
            }
        }
        .btn-confirm{
            height: 44px;
            line-height: 44px;
            border-radius: 4px;
            text-align: center;
            font-size: 16px;
            margin-top: 70px;
            color:#fff;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            &.disabled{
                color:#999;
                background: #DCDCDC;
            }
        }
    }
}
</style>